const NoPage = (): JSX.Element => {
  return <h1>404</h1>;
};

export default NoPage;
